var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { createGuid } from "@/common/utils/idUtilities";
import { shutdown } from "@/common/utils/eventHandlers";
/**
 * Recalls the app id from session storage. If id cannot be found then creates a new id
 * and stores is in session storage.
 * */
var recallOrGenerateAppId = function () {
    var id = window.name; // see https://stackoverflow.com/a/35596134
    if (!id) {
        id = createGuid();
        window.sessionStorage.setItem("appId", id);
        window.name = id;
    }
    return id;
};
/**
 * Remove given id from local storage.
 * @param id Id to remove.
 */
var removeFromLocalStore = function (id) {
    var ids = localStoreAppIds();
    var index = ids.indexOf(id);
    if (index != -1) {
        ids.splice(index, 1);
        localStoreAppIds(ids);
    }
};
/**
 * Get/set application ids in local storage.
 * @param newIds Ids to persist in local storage.
 */
var localStoreAppIds = function (newIds) {
    var ids = [];
    var appIds = localStorage.getItem("appIds");
    if (appIds) {
        ids = appIds.split(",");
    }
    if (newIds) {
        localStorage.setItem("appIds", newIds.join(","));
    }
    return ids;
};
/**
 * Asiointi application id.
 * */
export var appId = recallOrGenerateAppId();
/**
 * Store the given application id in local storage.
 * @param id Application id to store.
 */
export var storeInLocalStorage = function (id) {
    var ids = localStoreAppIds();
    if (!ids.includes(id)) {
        ids.push(id);
        localStoreAppIds(ids);
    }
};
/**
 * Perform shutdown (ie. release locks) for all application ids in local storage.
 * Finally, empty local storage.
 * */
export var shutdownLocalStorageApps = function () {
    var e_1, _a;
    var ids = localStoreAppIds();
    try {
        for (var ids_1 = __values(ids), ids_1_1 = ids_1.next(); !ids_1_1.done; ids_1_1 = ids_1.next()) {
            var id = ids_1_1.value;
            shutdown(id);
            removeFromLocalStore(id);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (ids_1_1 && !ids_1_1.done && (_a = ids_1.return)) _a.call(ids_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
};
